import { render, staticRenderFns } from "./Pet.vue?vue&type=template&id=9fc4231c&scoped=true&"
import script from "./Pet.vue?vue&type=script&lang=js&"
export * from "./Pet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc4231c",
  null
  
)

export default component.exports